module.exports = __webpack_public_path__ + "img/22.443bd7bf.jpg";